import workerSrc from 'pdfjs-dist/build/pdf.worker.min.js?url'
import { client } from './client'

// ModalContract scrolls HTML. The CPF pieces are PDFs, so each page becomes an image
// the existing popup can scroll (S3 itself sends no CORS header to the inscription origin).
export async function loadCpfDocumentHtml(globalId: string, kind: 'program' | 'internal_rules'): Promise<string> {
  const pdfjs = await import('pdfjs-dist')
  pdfjs.GlobalWorkerOptions.workerSrc = workerSrc
  const resp = await client.get<ArrayBuffer>(`/registration/${globalId}/cpf_document_preview/`, {
    params: { kind },
    responseType: 'arraybuffer',
    timeout: 60_000,
  })
  const pdf = await pdfjs.getDocument({ data: new Uint8Array(resp.data) }).promise
  try {
    const pages: string[] = []
    // The popup shows each page at about 1000px. A 1.4× jpeg looks soft once stretched,
    // and worse on a retina screen. Draw at the display size × device pixels, capped at 2.
    const pixelRatio = Math.min(window.devicePixelRatio || 1, 2)
    for (let number = 1; number <= pdf.numPages; number++) {
      const page = await pdf.getPage(number)
      const base = page.getViewport({ scale: 1 })
      const viewport = page.getViewport({ scale: (1000 / base.width) * pixelRatio })
      const canvas = document.createElement('canvas')
      canvas.width = Math.floor(viewport.width)
      canvas.height = Math.floor(viewport.height)
      const context = canvas.getContext('2d')
      if (!context) throw new Error('canvas unavailable')
      await page.render({ canvasContext: context, viewport }).promise
      pages.push(
        `<img alt="" width="${Math.round(base.width)}" height="${Math.round(
          base.height,
        )}" src="${canvas.toDataURL('image/jpeg', 0.92)}" style="width:100%;height:auto;display:block" />`,
      )
    }
    return pages.join('')
  } finally {
    await pdf.destroy()
  }
}
